import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

type Props = {
  icon: LucideIcon;
  label: string;
  isActive?: boolean;
  onClick: () => void;
};

export default function BottomNavItem({ icon: Icon, label, isActive = false, onClick }: Props) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  return (
    <button
      onClick={handleClick}
      className="flex-1 flex flex-col items-center justify-center py-2"
      type="button"
    >
      <Icon
        size={24}
        className={`mb-1 transition-colors ${
          isActive ? 'text-orange-500' : 'text-gray-500'
        }`}
      />
      <span
        className={`text-xs transition-colors ${
          isActive ? 'text-orange-500 font-medium' : 'text-gray-500'
        }`}
      >
        {label}
      </span>
    </button>
  );
}